import { useQuery } from '@tanstack/react-query';
import { Card, MessageBar, MessageBarBody, Spinner, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, Text, makeStyles, tokens } from '@fluentui/react-components';
import { AUDIT_ACTION_LABELS, type AuditEntry } from '@vxh/shared';
import { api } from '../api';
import { PageHeader } from '../components/PageHeader';
import { fullTime } from '../format';

const useStyles = makeStyles({ muted: { color: tokens.colorNeutralForeground3 }, tableWrap: { overflowX: 'auto' } });

/** Who signed in, who opened which instance, and what changed. Metadata only. */
export function AuditPage() {
  const s = useStyles();
  const q = useQuery({ queryKey: ['audit'], queryFn: () => api<AuditEntry[]>('/audit?limit=300'), refetchInterval: 30_000 });
  return (
    <>
      <PageHeader title="Activity" subtitle="Sign-ins, instances opened and changes made. The most recent 300 entries." />
      <Card>
        {q.isLoading ? <Spinner label="Loading" /> : q.isError ? (
          <MessageBar intent="error"><MessageBarBody>{(q.error as Error).message}</MessageBarBody></MessageBar>
        ) : (
          <div className={s.tableWrap}>
            <Table aria-label="Activity">
              <TableHeader>
                <TableRow>
                  <TableHeaderCell>When</TableHeaderCell>
                  <TableHeaderCell>Who</TableHeaderCell>
                  <TableHeaderCell>What</TableHeaderCell>
                  <TableHeaderCell>Instance or document</TableHeaderCell>
                  <TableHeaderCell>From</TableHeaderCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {(q.data ?? []).map((a) => (
                  <TableRow key={a.id}>
                    <TableCell>{fullTime(a.at)}</TableCell>
                    <TableCell>{a.actorEmail ?? <span className={s.muted}>-</span>}</TableCell>
                    <TableCell><Text>{AUDIT_ACTION_LABELS[a.action] ?? a.action}</Text></TableCell>
                    <TableCell>{a.instanceName ?? (typeof a.detail.name === 'string' ? a.detail.name : <span className={s.muted}>-</span>)}</TableCell>
                    <TableCell>{a.ip ?? <span className={s.muted}>-</span>}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </Card>
    </>
  );
}
